<template>
  <el-dialog
    title="完善收款信息"
    :visible="showPerfect"
    @close="eventClose"
    width="780px"
    top="200px"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-click-escape="false"
    center
    class="hello"
  >
    <div style="text-align:center;margin-bottom:30px;">
      收款信息将会用于和客户签约电子结算单，为保证电子结算单的正常签约，请务必完善以下收款信息
    </div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
      style="padding:0 170px 30px 170px;"
    >
      <el-form-item label="单位名称：">
        <el-input
          v-model="user.userName"
          style="width:288px;"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item label="开户银行：" prop="invoiceOpenBank">
        <el-input
          v-model="ruleForm.invoiceOpenBank"
          style="width:288px;"
        ></el-input>
      </el-form-item>
      <el-form-item label="银行账号：" prop="invoiceBankNo">
        <el-input
          v-model="ruleForm.invoiceBankNo"
          style="width:288px;"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系电话：" prop="phone">
        <el-input v-model="ruleForm.phone" style="width:288px;"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
          style="position:absolute;left:50%;margin-left:-50px;"
        >
          提交
        </el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<style>
.hello .el-dialog__body {
  padding: 0;
}
</style>

<script>
import { mapState, mapMutations } from 'vuex';
import { getStorage, setStorage } from '@/tools/storage';
import { csoUserKz } from '@/api/ajax';
export default {
  data() {
    return {
      user: getStorage('user'),
      ruleForm: {
        invoiceOpenBank: '',
        invoiceBankNo: ''
      },
      rules: {
        invoiceOpenBank: [
          {
            required: true,
            message: '请输入开户银行名称',
            trigger: 'blur'
          }
        ],
        invoiceBankNo: [
          {
            required: true,
            message: '请输入正确的银行卡号',
            trigger: 'change',
            min: 12,
            max: 19
          }
        ],
        phone: [
          {
            required: true,
            message: '请输入正确的联系方式',
            trigger: 'change'
          }
        ]
      }
    };
  },
  props: {
    showPerfect: {
      type: Boolean
    }
  },
  computed: {
    ...mapState({
      dialogFormVisible: state => state.dialogFormVisible
    })
  },
  methods: {
    ...mapMutations(['SHOWDETAIL']),
    eventClose() {
      // this.$parent.showFlag = false
      // this.$message({
      //   type: 'info',
      //   message: '取消输入'
      // });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          csoUserKz.addUpdateCsoUserKzDetail(this.ruleForm).then(() => {
            this.$message({
              type: 'success',
              message: '提交成功'
            });
            let obj = {
              enterpriseAuthStatus: '1',
              frameAgreementStatus: '1',
              invoiceOpenBank: this.ruleForm.invoiceOpenBank,
              invoiceBankNo: this.ruleForm.invoiceBankNo
            };
            setStorage('otherInfo', obj);
            this.$parent.showFlag = false;
          });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  created() {}
};
</script>
